/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { ref, onMounted, createApp, nextTick, watch, reactive } from "vue";
import Tabs from "@/class/Tabs";

export default function useAnchor() {
  onMounted(() => {
    let article = document.getElementById("layout-article");

    article!.addEventListener("click", function (event) {
      let ev = event || window.event;
      var target = ev.target as HTMLInputElement;
      let href = target!.getAttribute("href") as string;

      if (href && href[0] == "#") {
        if (ev.preventDefault) {
          ev.preventDefault();
        }

        let t = href.split("#")[1];
        let dest = document.getElementById(t);
        dest!.scrollIntoView();

        return false;
      }
    });
  });

  return {};
}
